export const getViewportWidth = () => {
    return document.body.clientWidth;
};

export const getViewportHeight = () => {
    return window.innerHeight;
};
